export const ADD_WIDGET = "ADD_WIDGET";
export const DELETE_WIDGET = "DELETE_WIDGET";
export const UPDATE_WIDGET = "UPDATE_WIDGET";
export const SET_WIDGETS = "SET_WIDGETS";
export const SET_CURRENT_WIDGET_ID = "SET_CURRENT_WIDGET_ID";
export const RESET_CURRENT_WIDGET_ID = "RESET_CURRENT_WIDGET_ID";
export const ADD_PREVIEW_WIDGET = "ADD_PREVIEW_WIDGET";
export const DELETE_PREVIEW_WIDGET = "DELETE_PREVIEW_WIDGET";
export const UPDATE_PREVIEW_WIDGET = "UPDATE_PREVIEW_WIDGET";
export const SET_PREVIEW_WIDGETS = "SET_PREVIEW_WIDGETS";
export const SET_DASHBOARD_CONTAINER = "SET_DASHBOARD_CONTAINER";
export const SET_KPI_DASHBOARD_CONTAINER = "SET_KPI_DASHBOARD_CONTAINER";
export const ADD_DASHBOARD_CONTAINER = "ADD_DASHBOARD_CONTAINER";
export const ADD_DASHBOARD = "ADD_DASHBOARD";
export const SET_DASHBOARD = "SET_DASHBOARD";
export const SET_KPI_DASHBOARD = "SET_KPI_DASHBOARD";
export const DELETE_DASHBOARD = "DELETE_DASHBOARD";
export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const SET_CURRENT_DASHBOARD_ID = "SET_CURRENT_DASHBOARD_ID";
export const RESET_CURRENT_DASHBOARD_ID = "RESET_CURRENT_DASHBOARD_ID";
export const DELETE_DASHBOARD_CONTAINER = "DELETE_DASHBOARD_CONTAINER";
export const UPDATE_DASHBOARD_CONTAINER = "UPDATE_DASHBOARD_CONTAINER";
export const ADD_DASHBOARD_TO_CONTAINER = "ADD_DASHBOARD_TO_CONTAINER";
export const REMOVE_DASHBOARD_FROM_CONTAINER = "REMOVE_DASHBOARD_FROM_CONTAINER";
export const ADD_FILTER = "ADD_FILTER";
export const DELETE_FILTER = "DELETE_FILTER";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const SET_FILTERS = "SET_FILTERS";
export const SET_SETTINGS = "SET_SETTINGS";
export const ADD_SETTING = "ADD_SETTING";
export const REMOVE_SETTING = "REMOVE_SETTING";
export const UPDATE_SETTING = "UPDATE_SETTING";
export const SET_USER_INFO = "SET_USER_INFO";
export const UPDATE_WIDGET_HASH = "UPDATE_WIDGET_HASH";
export const SET_USER_APPS = "SET_USER_APPS";
